import { render, staticRenderFns } from "./CookieWall.vue?vue&type=template&id=27dccb73&scoped=true&"
import script from "./CookieWall.vue?vue&type=script&lang=ts&"
export * from "./CookieWall.vue?vue&type=script&lang=ts&"
import style0 from "./CookieWall.vue?vue&type=style&index=0&id=27dccb73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dccb73",
  null
  
)

export default component.exports